import KeyDto from '@/common/classes/VisitorDocumentList/KeyDto'
import VisitorDocumentListItem from '@/common/classes/VisitorDocumentList/VisitorDocumentListItem'

/**
 * @readonly
 * @member {string} owner
 * @member {string} type
 */
export default class KeyItemPairDto {
  key
  item

  /**
   * @param {KeyDto} key
   * @param {VisitorDocumentListItem} item
   */
  constructor({ key, item }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    item = new VisitorDocumentListItem(item)
    key = new KeyDto(key)

    Object.defineProperty(this, 'item', Object.assign({ value: item }, properties))
    Object.defineProperty(this, 'key', Object.assign({ value: key }, properties))
    Object.freeze(this)
  }
}
